import { useParams, Link } from "react-router-dom";
import { getCategoryBySlug } from "../content/marketplace-content-loader";
import { SIGNUP_FORM_URL } from "../external-links";

/* ────── Utility Icons ────── */

function StarIcon() {
  return (
    <svg viewBox="0 0 12 12" fill="#C4993C" stroke="none">
      <path d="M6 .8l1.5 3 3.3.5-2.4 2.3.6 3.4L6 8.2 3 10l.6-3.4L1.2 4.3l3.3-.5z" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg viewBox="0 0 12 12" fill="none" stroke="#A89CA4" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2v6M3.5 5.5L6 8l2.5-2.5" />
      <path d="M2.5 10h7" />
    </svg>
  );
}

function ChevronLeftIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 3L5 8l5 5" />
    </svg>
  );
}

/* ────── Page Component ────── */

export function MarketplaceCategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;

  if (!category) {
    return (
      <div className="cat-not-found">
        <h1>Category not found</h1>
        <p>The category you're looking for doesn't exist.</p>
        <Link to="/marketplace" className="cat-back-link">
          Back to Marketplace
        </Link>
      </div>
    );
  }

  return (
    <>
      {/* ===== BREADCRUMB ===== */}
      <nav className="cat-breadcrumb">
        <Link to="/marketplace" className="cat-breadcrumb-link">
          <ChevronLeftIcon />
          Marketplace
        </Link>
      </nav>

      {/* ===== HERO ===== */}
      <section className="cat-hero">
        <div
          className="cat-hero-icon"
          style={{ background: category.color }}
        >
          {category.icon}
        </div>
        <h1 className="cat-hero-title">
          {category.name}
          <span className="cat-hero-accent">.</span>
        </h1>
        <p className="cat-hero-subtitle">{category.desc}</p>
        <span className="cat-hero-count">{category.count} guides available</span>
      </section>

      {/* ===== GUIDES GRID ===== */}
      <section className="cat-skills-section">
        <div className="cat-skills-grid">
          {category.guides.map((guide) => (
            <div key={guide.name} className="cat-skill-card">
              <div className="cat-skill-card-header">
                <div
                  className="cat-skill-dot"
                  style={{ background: category.color }}
                />
                <div>
                  <h3 className="cat-skill-name">{guide.name}</h3>
                  <span className="cat-skill-author">{guide.author}</span>
                </div>
              </div>
              <p className="cat-skill-desc">{guide.desc}</p>
              <div className="cat-skill-footer">
                <div className="cat-skill-meta">
                  <span className="cat-skill-badge">
                    <StarIcon /> {guide.rating}
                  </span>
                  <span className="cat-skill-badge">
                    <DownloadIcon /> {guide.installs}
                  </span>
                </div>
                <a href={SIGNUP_FORM_URL} target="_blank" rel="noopener noreferrer" className="protocol-install-btn">
                  Install
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== BACK CTA ===== */}
      <section className="cat-back-cta">
        <Link to="/marketplace" className="hero-cta-ghost">
          Browse all categories
        </Link>
      </section>
    </>
  );
}
